import { createClient } from '@supabase/supabase-js';
import { createLogger } from '../../config/logger';

const logger = createLogger('supabaseClient');

// Get environment variables with fallback values to prevent errors
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLIC_KEY;

// Log whether environment variables were loaded or fallbacks are being used
logger.debug('Supabase client initialized', {
    usingEnvUrl: !!process.env.REACT_APP_SUPABASE_URL,
    usingEnvKey: !!process.env.REACT_APP_SUPABASE_PUBLIC_KEY,
});

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true, // Disables persistent sessions for security
        detectSessionInUrl: true, // Detects token in URL for new sessions
    },
});
